'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loginErrorReset = exports.LOGOUT_SUCCESS = exports.LOGIN_SUCCESS = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.load = load;
exports.login = login;
exports.logout = logout;

var _loginCookieUtils = require('../../helpers/loginCookieUtils');

var _docs = require('./docs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'redux-example/auth/LOAD';
var LOAD_SUCCESS = 'redux-example/auth/LOAD_SUCCESS';
var LOAD_FAIL = 'redux-example/auth/LOAD_FAIL';
var LOGIN = 'redux-example/auth/LOGIN';
var LOGIN_SUCCESS = exports.LOGIN_SUCCESS = 'redux-example/auth/LOGIN_SUCCESS'; // pouziva se v docs.js
var LOGIN_FAIL = 'redux-example/auth/LOGIN_FAIL';
var LOGOUT = 'redux-example/auth/LOGOUT';
var LOGOUT_SUCCESS = exports.LOGOUT_SUCCESS = 'redux-example/auth/LOGOUT_SUCCESS';
var LOGOUT_FAIL = 'redux-example/auth/LOGOUT_FAIL';
var LOGIN_ERROR_RESET = 'redux-example/auth/LOGIN_ERROR_RESET';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        user: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case LOGIN:
      return (0, _extends3.default)({}, state, {
        loggingIn: true
      });
    case LOGIN_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        user: action.result
      });
    case LOGIN_FAIL:
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        user: null,
        loginError: action.error
      });
    case LOGIN_ERROR_RESET:
      return (0, _extends3.default)({}, state, {
        loginError: null
      });
    case LOGOUT:
      return (0, _extends3.default)({}, state, {
        loggingOut: true
      });
    case LOGOUT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        // loggingOut: false,
        user: null
      });
    case LOGOUT_FAIL:
      return (0, _extends3.default)({}, state, {
        loggingOut: false,
        logoutError: action.error
      });
    case _docs.PL_UPDATE_FAILED:
    case _docs.PL_CREATE_FAILED:
      // chyba pri nacteni playlistu - workaround kvuli dialogu, ale melo by byt jinak - klasický dialog
      return (0, _extends3.default)({}, state, {
        // user: null,
        loginError: { message: action.error.priorityMessage || 'error occured :-(' }
      });

    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.auth && globalState.auth.loaded;
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/loadAuth');
    }
  };
}

// export function preLogin() {
//   return {
//     type: LOGIN
//   };
// }

function login(token, serviceName) {
  var setCookieAfterLogin = function setCookieAfterLogin(userObj) {
    // console.log('UserOBJ= ' + JSON.stringify(userObj, null, 5));
    if (userObj.error) {
      // alert(userObj.error);
      return false;
    }
    // do cookie si ulozime jmno servisy pro prihlasovani
    (0, _loginCookieUtils.setServiceName)(serviceName);
    window.agamaToken = userObj.token;
    return userObj;
  };

  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post('/agamaLogin', {
        data: {
          token: token,
          serviceName: serviceName
        }
      }).then(setCookieAfterLogin);
    }
  };
}

// export function isLoaded(globalState) {
//   return globalState.widgets && globalState.widgets.loaded;
// }

// export const shouldAutomaticLogin = () => {
//   const serviceName = getCookie(loginCookieName);
//   console.log('hodnota cookie je ' + serviceName);
//   return serviceName;
// };

function logout() {
  // vymažeme cookie
  (0, _loginCookieUtils.deleteServiceName)();
  return {
    type: LOGOUT_SUCCESS
  };
}

var loginErrorReset = exports.loginErrorReset = function loginErrorReset() {
  return {
    type: LOGIN_ERROR_RESET
  };
};
// export function logout() {
//   return {
//     types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL],
//     promise: (client) => client.get('/logout')
//   };
// }
// 1 https://www.facebook.com/dialog/oauth?client_id=226342524229749&redirect_uri=http://www.agama2000.com
// 2 http://www.agama2000.com/?code=AQAYKBveUhartwx9JILfLmGYeKouPnBUHo2h7t8295wG4bLiVaUpFgG5Ian8bM1LBSWoudajXu-J8qphyo-spZfGL5gGEsy4aeFLK1ILKC5yKK_Boh7dRUt8NRWceuyD6r3tqbattmI407KYc12UcKer9zUBCEt9giNtAJJDGVOCsjyf5ps0fEMS2bZufC0NC172FNOzYepQvGI3i2pAljiUQhZDH4NXneCwVk6KFoA2fLr-A-7IkL-TUJVF-R1BFDkvmr6dyJcPcjLpql45ZHt65JTWxE-XoOVCB0s7njUWrYbQym9ZK-G-AkATTzQJIaQIUgCc-RlBeIhDcg9i2U0O#_=_
// 3 Poslat na FB párování


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/auth.js
// module id = 62
// module chunks = 0